<template>
  <el-form
    class="form-box"
    :inline="true"
    label-position="right"
    @submit.native.prevent
  >
    <el-form-item
      v-for="(fItem, fIndex) in formList"
      :key="fIndex"
      :label="fItem.label"
      size="mini"
    >
      <el-input
        v-if="fItem.type == 'input'"
        v-model="fItem.value"
        :type="fItem.types"
        :placeholder="fItem.placeholder"
        :maxlength="fItem.maxlength"
        :rows="fItem.rowss"
        @keyup.enter.native="fItem.prop != 'orderIds' && searchHandle"
      ></el-input>
      <el-select
        v-if="fItem.type == 'select'"
        v-model="fItem.value"
        :multiple="fItem.isMultiple || false"
        :collapse-tags="fItem.isMultiple || false"
        placeholder=""
      >
        <el-option
          v-for="item in fItem.options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      <el-date-picker
        v-if="fItem.type == 'datetimerange'"
        v-model="fItem.value"
        type="datetimerange"
        value-format="yyyy-MM-dd HH:mm:ss"
        :picker-options="pickerOptionsNormal"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        align="right"
        @change="handleTimeChange"
      ></el-date-picker>
      <el-date-picker
        v-if="fItem.type == 'datetimerange-jp'"
        v-model="fItem.value"
        type="datetimerange"
        value-format="yyyy-MM-dd HH:mm:ss"
        :picker-options="pickerOptionsNormal"
        range-separator="～"
        start-placeholder="開始日"
        end-placeholder="終了日"
        align="right"
        @change="handleTimeChange"
        popper-class="pay-date-picker"
      ></el-date-picker>
      <el-date-picker
        v-if="fItem.type == 'daterange'"
        v-model="fItem.value"
        type="daterange"
        value-format="yyyy-MM-dd HH:mm:ss"
        :picker-options="pickerOptions3"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        align="right"
        @change="handleTimeChange"
        @input="handleInput"
      ></el-date-picker>
    </el-form-item>
    <el-form-item class="operate-btn">
      <el-button
        type="primary"
        size="mini"
        class="filter"
        @click="searchHandle"
      >
        {{ type ? '筛选' : 'フィルター' }}
      </el-button>
      <slot></slot>
      <el-button type="text" size="mini" @click="resetHandle">
        {{ type ? '清空筛选条件' : 'フィルター条件をクリアする' }}
      </el-button>
    </el-form-item>
    <!-- <el-form-item>
    </el-form-item>
    <el-form-item>
    </el-form-item>-->
  </el-form>
</template>
<script>
import moment from 'moment';

export default {
  props: {
    formList: Array,
    type: {
      default: true,
      type: Boolean,
    },
  },
  data() {
    return {
      value: '',
      pickerOptionsNormal: utils.pickerOptionsNormal,
      pickerOptions3: {
        shortcuts: [
          {
            text: '今天',
            onClick(picker) {
              picker.$emit('pick', [
                new Date(moment().format('YYYY-MM-DD 00:00:00')),
                new Date(moment().format('YYYY-MM-DD 23:59:59')),
              ]);
            },
          },
          {
            text: '昨天',
            onClick(picker) {
              const beginTime = new Date(
                moment()
                  .subtract(1, 'days')
                  .format('YYYY-MM-DD 00:00:00')
              );
              const endTime = new Date(
                moment()
                  .subtract(1, 'days')
                  .format('YYYY-MM-DD 23:59:59')
              );

              picker.$emit('pick', [beginTime, endTime]);
            },
          },
          {
            text: '最近7天',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: '最近30天',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: '这个月',
            onClick(picker) {
              const beginTime = new Date(
                moment()
                  .startOf('month')
                  .format('YYYY-MM-DD 00:00:00')
              );
              const endTime = new Date(
                moment()
                  .endOf('month')
                  .format('YYYY-MM-DD 23:59:59')
              );
              picker.$emit('pick', [beginTime, endTime]);
            },
          },
          {
            text: '上个月',
            onClick(picker) {
              const base = moment()
                .subtract(1, 'months')
                .startOf('month');
              const beginTime = new Date(base.format('YYYY-MM-DD HH:mm:ss'));
              const endTime = new Date(
                base.endOf('month').format('YYYY-MM-DD 23:59:59')
              );
              picker.$emit('pick', [beginTime, endTime]);
            },
          },
        ],
      },
      isGroup: false,
    };
  },
  mounted() {
    this.originFormList = _.cloneDeep(this.formList);
  },
  methods: {
    handleInput() {
      console.log('执行');
    },
    _initSearch() {
      const searchObj = {};
      this.formList.forEach(item => {
        if (utils.isNotEmpty(item.value)) {
          searchObj[item.prop] = item.value;
          // console.log(item.value.split('\n'),"数据2")//临时查看
        }
      });
      return searchObj;
    },
    searchHandle() {
      this.$emit('searchHandle', this._initSearch());
      // console.log(this.formList[1].value.split('\n'),'数据')//临时查看
    },
    handleTimeChange() {
      this.searchHandle();
    },
    // 清空表单
    resetForm() {
      this.formList.forEach((item, index) => {
        item.value = this.originFormList[index].value;
      });
    },
    resetHandle() {
      this.formList.forEach((item, index) => {
        item.value = this.originFormList[index].value;
      });
      if (this.$route.query?.userId) {
        this.$route.query.userId = '';
      }
      this.$parent.pageIndex = 1; // todo 不应该在这里, 由上层handle来做
      this.$emit('searchHandle', this._initSearch());
    },
  },
};
</script>
<style lang="scss">
.pay-date-picker .el-picker-panel__shortcut {
  padding: 0;
}
.form-box {
  background: #fff;
  box-sizing: border-box;
  padding: 20px 0 0 20px;
  margin-bottom: 15px;
  .el-input .el-input__inner {
    height: 28px;
  }
  .el-form-item__content {
    line-height: 100%;
    .el-textarea__inner {
      min-height: 28px !important; //子订单最小行高覆盖
    }
  }
  .el-date-editor--datetimerange.el-input__inner {
    width: 360px;
  }
  .operate-btn .el-form-item__content {
    display: flex !important;
    .filter {
      margin-right: 20px;
    }
  }
}
</style>
